import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { installBackdropClickGuard } from './utils/backdropClickGuard';

installBackdropClickGuard();

// Scrolling the mouse wheel over a focused number field must not change its value.
document.addEventListener('wheel', () => {
  const el = document.activeElement;
  if (el && el.tagName === 'INPUT' && el.type === 'number') el.blur();
}, { passive: true });

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);